import { GOOGLE_MAPS_API_KEY } from 'redux/config/services/Constants'

const BASE_ROUTES_URL = 'https://routes.googleapis.com'

export const computeRoute = async (
  startingDestinationLatLong: { latitude: number; longitude: number },
  endingDestinationLatLong: { latitude: number; longitude: number },
  departureTime: string // ISO string
): Promise<Response> => {
  const url = `${BASE_ROUTES_URL}/directions/v2:computeRoutes`

  const requestBody = {
    origin: {
      location: {
        latLng: startingDestinationLatLong,
      },
    },
    destination: {
      location: {
        latLng: endingDestinationLatLong,
      },
    },
    travelMode: 'TRANSIT',
    computeAlternativeRoutes: true,
    // Not using the departureTime for now
    // because openai is sending wrong iso string
    // and to accurately get the departure time we need the user timezone
    // departureTime: departureTime,
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Goog-Api-Key': GOOGLE_MAPS_API_KEY,
      'X-Goog-FieldMask':
        'routes.duration,routes.polyline,routes.routeLabels,routes.distanceMeters,routes.legs',
    },
    body: JSON.stringify(requestBody),
  })
}
